<header class="header">
  <section class="position-fixed w-100 top-0 header-logo-links d-flex align-items-center" [ngClass]="{'justify-content-between': isMobView}">
    <div class="logo-wrapper mx-4" [ngClass]="{ 'overlay_index': showMenu }">
      <a class="d-flex w-100 justify-content-center" [href]="originUrl">
        <img class="w-75" src="/cs/cop/assets/images/Avaya-OneCare-Portal-Logo.png" alt="Avaya Sales &amp; Partner Portal" />
      </a>
    </div>

    <!-- for mobile view only -->
    <div class="position-relative d-block d-md-none me-3" [ngClass]="{ 'overlay_index': showMenu }">
      <mat-icon class="cursor-pointer" (click)="showMenu = !showMenu">
        @if (showMenu) { close } @else { menu }
      </mat-icon>
    </div>

    <!-- enable backdrop, if necessary -->
    <!-- @if (showMenu) {
      <div class="offcanvas-backdrop fade show d-md-none" (click)="showMenu = false" style="z-index: 1040;"></div>
    } -->

    <!-- Header menus for public page -->
    @if (!isAvayaCloudOffice && !isAvayaCCass && !isAvayaCloudPrivate) {
      <ul class="header-links" [class.show]="showMenu" [ngClass]="{ 'flex-row align-items-center': !isMobView }">
        <!-- Left side menus -->
        @for (link of leftMenus; track link.id) {
          <li class="menuList cursor-pointer position-relative" copDropdown (clickOutside)="closeMenuItems()" [ngClass]="{ 'me-3': !isMobView }">
            <a class="d-flex align-items-center menu_label" (click)="linkTarget(link, self)" [ngClass]="{'justify-content-between': showMenu}">
              {{ link.title }}
              @if (link.HasSubHeaderLink) { <mat-icon class="ms-1 caret_icon">keyboard_arrow_down</mat-icon> }
            </a>

            @if (link.HasSubHeaderLink && !hideListMenus) {
              <ul class="bg-white menu-dropdown" [ngClass]="{'position-absolute': !isMobView, 'mt-2': isMobView}">
                @for (sub of link.SubHeaderLinks; track sub.id) {
                  <li copSubDropdown class="menu">
                    <a href="{{ sub.url }}" class="d-flex w-100 px-3 py-2">
                      {{ sub.title }}
                    </a>
                  </li>
                }
              </ul>
            }
          </li>
        }

        <!-- Right side menus -->
        @for(link of rightMenus; track link.id) {
          @if (link.alttext === 'language') {
            <li class="menuList cursor-pointer position-relative" copDropdown (clickOutside)="closeMenuItems()" [ngClass]="{ 'me-3 ms-auto': !isMobView }">
              <a class="d-flex align-items-center" (clickOutside)="closeLanguageDropdown()">
                <!-- Language icon min-width: 768px -->
                <span (click)="openLanguageDropdown()" class="cursor-pointer d-md-block d-none">
                  <mat-icon class="thin-icon fs-3" [ngClass]="{'mt-2': isNoLeftMenus}">language</mat-icon>
                </span>

                <!-- Language label max-width: 767px -->
                <span class="cursor-pointer d-flex d-md-none" (click)="openLanguageDropdown()" [ngClass]="{'justify-content-between': showMenu}">
                  <span class="d-flex align-items-center">
                    <mat-icon class="thin-icon fs-3 me-2">language</mat-icon>
                    <span class="fw-light">{{ link.title }}</span>
                  </span>
                  <mat-icon class="ms-1">keyboard_arrow_down</mat-icon>
                </span>
              </a>
              <ul class="bg-white menu-dropdown" [ngClass]="{'position-absolute': !isMobView, 'mt-2': isMobView}">
                @for (sub of link.SubHeaderLinks; track sub.id) {
                  <li copSubDropdown class="menu">
                    <a href="{{sub.url}}" class="d-flex justify-content-between align-items-center w-100 px-3 py-2">
                      {{ sub.title }}
                      @if (sub.isSelectedLang) { <mat-icon class="fs-5">check</mat-icon> }
                    </a>
                  </li>
                }
              </ul>
            </li>
          }
          @if (link.alttext === 'signin' && userInfo.usertype && userInfo.usertype == 'Public') {
            <li class="menuList cursor-pointer" [ngClass]="{ 'me-3': !isMobView }">
              <a class="menu_label" href="{{ sinInLink?.url }}">{{ 'OneCareSignIn' | translate }}</a>
            </li>
          }
        }
      </ul>
    }

    <!-- Header menus in case of any specific view ex. AvayaCloudOffice, AvayaCCass, AvayaCloudPrivate, AvayaEnterpriseCloud, AvayaAuraPrivateCloud -->
    @if (isAvayaCloudOffice || isAvayaCCass || isAvayaCloudPrivate) {
      <ul class="header-links" [class.show]="showMenu" [ngClass]="{ 'flex-row align-items-center': !isMobView }">
        <!-- Left side header menus -->
        @for (link of leftMenus; track link.id) {
          <li class="menuList cursor-pointer position-relative" copDropdown (clickOutside)="closeMenuItems()" [ngClass]="{ 'me-3': !isMobView }">
            <a class="d-flex align-items-center menu_label" (click)="linkTarget(link, self)" [ngClass]="{'justify-content-between': showMenu}">
              {{ link.title }}
              <mat-icon class="ms-1 caret_icon" *ngIf="link.HasSubHeaderLink">keyboard_arrow_down</mat-icon>
            </a>

            @if (!hideListMenus && link.HasSubHeaderLink) {
              <ul class="bg-white menu-dropdown" [ngClass]="{'position-absolute': !isMobView, 'mt-2': isMobView}">
                @for (sub of link.SubHeaderLinks; track sub.id) {
                  <li copSubDropdown class="menu">
                    <a class="d-flex w-100 px-3 py-2" href="{{sub.url}}">
                      {{ sub.title }}
                    </a>
                  </li>
                }
              </ul>
            }
          </li>
        }

        <!-- Right side header menus -->
        <!-- Language menu -->
        @for (link of rightMenus; track link.id; let totalItems = $count) {
          @if (link.alttext === 'language') {
            <li class="menuList cursor-pointer ms-auto position-relative" copDropdown (clickOutside)="closeMenuItems()" [ngClass]="{ 'me-3 ms-auto': !isMobView }">
              <a class="d-flex align-items-center" (clickOutside)="closeLanguageDropdown()">
                <!-- Language icon min-width: 768px -->
                <span (click)="openLanguageDropdown()" class="cursor-pointer d-none d-md-block">
                  <mat-icon class="thin-icon fs-3" [ngClass]="{'mt-2': isNoLeftMenus}">language</mat-icon>
                </span>

                <!-- Language label max-width: 767px -->
                <span class="cursor-pointer d-flex d-md-none" (click)="openLanguageDropdown()" [ngClass]="{'justify-content-between': showMenu}">
                  <span class="d-flex align-items-center">
                    <mat-icon class="thin-icon fs-3 me-2">language</mat-icon>
                    <span class="fw-light">{{ link.title }}</span>
                  </span>
                  <mat-icon class="ms-1">keyboard_arrow_down</mat-icon>
                </span>
              </a>

              @if(!hideListMenus) {
                <ul class="bg-white menu-dropdown" [ngClass]="{'position-absolute': !isMobView, 'mt-2': isMobView}">
                  @for (sub of link.SubHeaderLinks; track sub.id) {
                    <li copSubDropdown class="menu">
                      <a href="{{sub.url}}" class="d-flex justify-content-between align-items-center w-100 px-3 py-2">
                        {{ sub.title }}
                        @if (sub.isSelectedLang) { <mat-icon>check</mat-icon> }
                      </a>
                    </li>
                  }
                </ul>
              }
            </li>
          }

          @if (link.alttext === 'signin') {
            <!-- sign-in menu for AvayaEnterpriseCloud, AvayaAuraPrivateCloud view only -->
            @if (!isCcasSess && isAvayaCloudPrivate) {
              <li class="menuList cursor-pointer position-relative" copDropdown (clickOutside)="closeMenuItems()" [ngClass]="{'ms-auto': (totalItems === 1) && !isMobView, 'me-3': !isMobView }">
                <a class="d-flex align-items-center menu_label" [attr.href]="link.HasSubHeaderLink ? null : sinInLink?.url" [ngClass]="{'justify-content-between': showMenu}">
                  {{ 'OneCareSignIn' | translate }}
                  @if (link.HasSubHeaderLink) { <mat-icon class="ms-1 caret_icon">keyboard_arrow_down</mat-icon> }
                </a>
                @if (!hideListMenus) {
                  <ul class="bg-white menu-dropdown " style="min-width: 175px;" [ngClass]="{'position-absolute': !isMobView, 'mt-2': isMobView}">
                    @for (sub of link.SubHeaderLinks; track sub.id) {
                      <li copSubDropdown class="menu">
                        <a class="d-flex w-100 px-3 py-2" href="{{ sub.url }}">{{ sub.title }}</a>
                      </li>
                    }
                  </ul>
                }
              </li>
            }

            <!-- sign-in menu for AvayaCloudOffice view only -->
            @if ((isAvayaCloudOffice && !ringSSoSession) || isAvayaCCass) {
              <li class="menuList cursor-pointer position-relative" [ngClass]="{ 'ms-auto': (totalItems === 1), 'me-3': !isMobView }">
                <a class="menu_label" href="{{ sinInLink?.url }}">
                  {{ 'OneCareSignIn'| translate }}
                </a>
              </li>
            }
          }
        }

        <!-- My ticket menu for AvayaCloudOffice view only -->
        @if (isRingSess && isAvayaCloudOffice) {
          <li (clickOutside)="closeMenuItems()" copDropdown class="menuList cursor-pointer position-relative" [ngClass]="{ 'me-3': !isMobView }">
            <a class="gradient_btn" [ngClass]="{'d-flex align-items-center': !isMobView}">
              <span [ngClass]="{'me-2' : isMobView}">{{ 'MyTicket' | translate }}</span>
              <mat-icon>keyboard_arrow_down</mat-icon>
            </a>
            <ul class="bg-white menu-dropdown" *ngIf="!hideListMenus" [ngClass]="{'position-absolute': !isMobView, 'mt-3': isMobView}">
              <li class="menu" (click)="OpenRequestsView('my')">
                <a class="d-flex w-100 px-3 py-2">{{ 'acoMyTickets' | translate }}</a>
              </li>
              <li class="menu" (click)="OpenRequestsView('history')">
                <a class="d-flex w-100 px-3 py-2">{{ 'Historyrequests' | translate }}</a>
              </li>
            </ul>
          </li>
        }

        <!-- My ticket menu for AvayaEnterpriseCloud, AvayaAuraPrivateCloud view only -->
        @if (isCcasSess && isAvayaCloudPrivate && ((userState === 'aim' && (userRoles.includes('onecareticketadmin') || userRoles.includes('onecareticketuser'))) || userState === 'sso')) {
          <li (clickOutside)="closeMenuItems()" copDropdown class="menuList cursor-pointer position-relative" [ngClass]="{ 'me-3': !isMobView }">
            <a class="gradient_btn" [ngClass]="{'d-flex align-items-center': !isMobView}">
              <span [ngClass]="{'me-2' : isMobView}">{{ 'MyTicket' | translate }}</span>
              <mat-icon class="ms-1">keyboard_arrow_down</mat-icon>
            </a>
            <ul class="bg-white menu-dropdown" *ngIf="!hideListMenus" [ngClass]="{'position-absolute': !isMobView, 'mt-3': isMobView}"
              [ngStyle]="{'width': userRoles.includes('admin') ? '205px' : '160px'}">
              <li class="menu" (click)="OpenRequestsView('my')">
                <a class="d-flex w-100 px-3 py-2">{{ 'acoMyTickets' | translate }}</a>
              </li>
              <li class="menu" (click)="OpenRequestsView('history')">
                <a class="d-flex w-100 px-3 py-2">{{ 'Historyrequests' | translate }}</a>
              </li>
              <li class="menu" *ngIf="userRoles.includes('admin') || userRoles.includes('onecareticketadmin')" (click)="OpenRequestsView('mycompanysr')">
                <a class="d-flex w-100 px-3 py-2">{{ 'myCompTickets' | translate }}</a>
              </li>
            </ul>
          </li>
        }

        <!-- Search menu -->
        @if (isSearchOpen) {
          <li class="menuList cursor-pointer" [ngClass]="{ 'me-3': !isMobView }">
            <a class="d-flex">
              <!-- Lens icon min-width: 768px -->
              <mat-icon *ngIf="!show" class="cursor-pointer d-none d-md-block" (click)="openSearchView()">search</mat-icon>

              <!-- Search label max-width: 767px -->
              <span *ngIf="!show" class="cursor-pointer d-flex align-items-center d-md-none" (click)="openSearchView()">
                <mat-icon class="thin-icon fs-3 me-2">search</mat-icon>
                <span class="fw-light">{{ 'search' | translate }}</span>
              </span>
            </a>
          </li>
        }

        <!-- User avatar menu for AvayaCloudOffice and AvayaEnterpriseCloud, AvayaAuraPrivateCloud view only -->
        @if ((isAvayaCloudOffice && isRingSess) || (isAvayaCloudPrivate && isCcasSess)) {
          <li copprofDropdown (clickOutside)="closeProfileDropdown()" class="menuList cursor-pointer position-relative" [ngClass]="{ 'me-3': !isMobView }">
            <a class="d-flex align-items-center">
              <mat-icon class="cursor-pointer thin-icon fs-3">account_circle</mat-icon>
              <span class="cursor-pointer d-inline-block ps-2 pt-1 d-md-none me-2 fw-light">{{ 'profile' | translate }}</span>
              @if (isMobView) { <mat-icon>keyboard_arrow_down</mat-icon> }
            </a>
            @if (!hideListMenus) {
              <ul class="bg-white menu-dropdown" [ngClass]="{'position-absolute': !isMobView, 'mt-2': isMobView}">
                <li class="menu">
                  @if (isAvayaCloudOffice && isRingSess) {
                    <a class="d-flex w-100 px-3 py-2" title="{{ ringSSoSession.userRole }}">
                      {{ ringSSoSession.firstName }} {{ ringSSoSession.lastName }}
                    </a>
                  }
                  @if (isAvayaCloudPrivate && isCcasSess) {
                    <a class="d-flex w-100 px-3 py-2" title="{{ CcassPrivateSession.userRole }}">
                      {{ CcassPrivateSession.firstName }} {{ CcassPrivateSession.lastName }}
                    </a>
                  }
                </li>
                <li class="menu">
                  @if (isAvayaCloudOffice && isRingSess) {
                    <a class="d-flex w-100 px-3 py-2 cursor-pointer" (click)="revokeSsoSesion()">{{ 'OneCareLogout' | translate }}</a>
                  }
                  @if (isAvayaCloudPrivate && isCcasSess) {
                    <a class="d-flex w-100 px-3 py-2 cursor-pointer" (click)="revokeAOCSession()">{{ 'OneCareLogout' | translate }}</a>
                  }
                </li>
              </ul>
            }
          </li>
        }
      </ul>
    }

    <!-- Search bar only visible after clicking on lens icon -->
    <div class="searchMainDiv" *ngIf="show">
      <div class="search-box-inner">
        <span><a><img src="/cs/cop/assets/svg/search-black.png" width="20"></a></span>
        <input type="text" class="searchInput" placeholder="{{ 'OneCareSearchPlaceholder' | translate }}"
          [(ngModel)]="searchStr" (keyup)="onLoginEventFired($event, searchStr)" autofocus #headSearch>
        {{ headSearch.focus() }}
      </div>
      <div (click)="show = !show">
        <mat-icon class="removeSearch">close</mat-icon>
      </div>
      <div class="easy-autocomplete-container" id="eac-container-searchInput" *ngIf="searchResponse?.body?.results.length > 0 && showDropHide">
        <ul>
          <li class="selected" *ngFor="let autoFill of searchResponse?.body?.results">
            <div class="eac-item" tabindex="1" (click)='searchDropDownSelect(autoFill.name)'><b>{{ autoFill.name }}</b>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>

  <!-- Not authorized dialog -->
  <div class="d-flex align-items-center justify-content-center overlay" *ngIf="isAccessDenied">
    <div class="d-flex flex-column align-items-center main_content">
      <h4 class="text-center m-0">{{ 'notAuthorized' | translate }}</h4>
      <h5 class="text-center m-0">{{ 'redirectingToHome' | translate }}</h5>
      <p class="mt-2">
        <button class="dismiss_btn" (click)="isAccessDenied = !isAccessDenied">{{ 'dismissMessage' | translate }}</button>
      </p>
    </div>
  </div>
</header>
